export default __webpack_public_path__ + "static/media/icon_answer_money.f179a6cd.svg";